import React from 'react';
//import css from './css.module.less';
import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import {
  ProductDetailPageTabBarStyle,
  addToCart,
  backgroundColor,
  productDetailsPageTabBarStyle,
  remindMe,
  soldOut,
  textColor,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearanc-revamp/constant';

import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
//import { get } from 'lodash';

import ColorPicker from 'src/components/Modules-revamp/ColorPicker';

const sectionProps = {
  size: 'small',
  style: { paddingTop: 0 },
};

const Top = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { breakpoint, disabled } = props;

  return (
    <Wrapper id={ProductDetailPageTabBarStyle} breakpoint={breakpoint}>
      <BlockTitle
        id={ProductDetailPageTabBarStyle}
        title={getI18n(
          'salesChannelContent.index.productDetailsPageButtonStyle',
        )}
        breakpoint={breakpoint}
        onReset={
          () => {
            return;
          } // handleOnSectionReset(item?.fields, breakpoint)
        }
        onCopy={
          () => {
            return;
          } // handleOnSectionCopy(item?.fields, breakpoint)}
        }
        headerErrorDependencies={[]}
        validator={() => {
          return;
        }}
      />
      <Section {...sectionProps}>
        <ItemWrapper
          title={getI18n('general.status')}
          bottomTitle={getI18n('general.status.active')}></ItemWrapper>
        <ItemWrapper
          title={`“${getI18n('salesChannelContent.index.addtoCart')}” ${getI18n(
            'general.buttonBackgroundColour',
          )}`}>
          <Field
            name={[productDetailsPageTabBarStyle, addToCart, backgroundColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
        <ItemWrapper
          title={`“${getI18n('salesChannelContent.index.addtoCart')}” ${getI18n(
            'general.buttonTextColour',
          )}`}>
          <Field name={[productDetailsPageTabBarStyle, addToCart, textColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
      </Section>
      <Section {...sectionProps}>
        <ItemWrapper
          title={getI18n('general.status')}
          bottomTitle={getI18n(
            'salesChannelContent.index.soldOut',
          )}></ItemWrapper>
        <ItemWrapper
          title={`“${getI18n('salesChannelContent.index.soldOut')}” ${getI18n(
            'general.buttonBackgroundColour',
          )}`}>
          <Field
            name={[productDetailsPageTabBarStyle, soldOut, backgroundColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
        <ItemWrapper
          title={`“${getI18n('salesChannelContent.index.soldOut')}” ${getI18n(
            'general.buttonTextColour',
          )}`}>
          <Field name={[productDetailsPageTabBarStyle, soldOut, textColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
        <ItemWrapper
          title={`“${getI18n('salesChannelContent.index.remindMe')}” ${getI18n(
            'general.buttonBackgroundColour',
          )}`}>
          <Field
            name={[productDetailsPageTabBarStyle, remindMe, backgroundColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
        <ItemWrapper
          title={`“${getI18n('salesChannelContent.index.remindMe')}” ${getI18n(
            'general.buttonTextColour',
          )}`}>
          <Field name={[productDetailsPageTabBarStyle, remindMe, textColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
      </Section>
    </Wrapper>
  );
};
export default Top;
